angular.module('BBPublicBooking').directive('bbCustomConfirmationText', () => {
        return {
            restrict: 'AE',
            replace: true,
            scope: true,
            controller: 'CustomConfirmationText'
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/custom-confirmation-text/bb_custom_confirmation_text.directive.js